export const version = "ethers/5.5.3";
//# sourceMappingURL=_version.js.map